module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Light-08c0fe7cf1fc44638c86c038dd137ad6.woff2";